import React from 'react';
import ReactDOM from 'react-dom';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
// ✅ ADD HERE
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
//import reportWebVitals from './reportWebVitals';
// import store from './Redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './Redux/store';
import { Provider } from 'react-redux';
import { HelmetProvider } from "react-helmet-async";
import { setToken, setUser, setUserDtaa } from './Redux/Rootreducer/Slices/Auth/authSlice';

const CHUNK_RETRY_KEY = 'retry_chunk_load_once';
const chunkErrorMessage = (error) => {
  const message = (error && (error.message || error.toString())) || '';
  return /ChunkLoadError|Loading chunk/i.test(message) || /vendors-node_modules_react-owl-carousel_umd_OwlCarousel_js/.test(message);
};

const reloadOnChunkError = (error) => {
  if (!chunkErrorMessage(error)) return;

  const alreadyRetried = sessionStorage.getItem(CHUNK_RETRY_KEY);
  if (alreadyRetried) {
    return;
  }

  sessionStorage.setItem(CHUNK_RETRY_KEY, '1');
  window.location.reload();
};

window.addEventListener('error', (event) => {
  reloadOnChunkError(event.error || event);
});

window.addEventListener('unhandledrejection', (event) => {
  reloadOnChunkError(event.reason);
});

window.addEventListener('load', () => {
  sessionStorage.removeItem(CHUNK_RETRY_KEY);
});

const user = localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : "";
const token = localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')) : "";


const userData = localStorage.getItem('userData') !== 'undefined' ? JSON.parse(localStorage.getItem('userData')) : {};


if (user && token) {
  store.dispatch(setUser(user));
  store.dispatch(setToken(token));
  store.dispatch(setUserDtaa(userData));

}


ReactDOM.render(

  
  <HelmetProvider>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
</HelmetProvider>,
  
  
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
